import { flow } from 'lodash';
import { NAME } from './apps.constant';

const selectStateKey = (state) => state[NAME];
const selectDataKey = (state) => state.data;
const selectLoadingKey = (state) => state.loading;
const selectErrorKey = (state) => state.error;
const selectFiltersKey = (state) => state.filters;

export const selectState = flow(selectStateKey);
export const selectData = flow(selectState, selectDataKey);
export const selectLoading = flow(selectState, selectLoadingKey);
export const selectError = flow(selectState, selectErrorKey);
export const selectFilters = flow(selectState, selectFiltersKey);
